import { render, staticRenderFns } from "./descriptive_stats_table.vue?vue&type=template&id=08935976&scoped=true&"
import script from "./descriptive_stats_table.vue?vue&type=script&lang=ts&"
export * from "./descriptive_stats_table.vue?vue&type=script&lang=ts&"
import style0 from "./descriptive_stats_table.vue?vue&type=style&index=0&id=08935976&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08935976",
  null
  
)

export default component.exports